module.exports = __webpack_public_path__ + "img/result-detail-last-message03.c119983e.svg";